import { render, staticRenderFns } from "./CostCenterAllocationModal.vue?vue&type=template&id=04ecbe01"
import script from "./CostCenterAllocationModal.vue?vue&type=script&lang=js"
export * from "./CostCenterAllocationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports